import React from "react";
import { VStack, Stack, Text } from "@chakra-ui/layout";
import { IconButton } from "@chakra-ui/button";
import { Image, Link } from "@chakra-ui/react";
import { FaTelegramPlane, FaTwitter, FaMediumM, FaFacebookF, FaLinkedinIn, FaGithub, FaYoutube } from "react-icons/fa";

import footerLogo from "assets/footer-logo.png";

const socials = [
  {
    Icon: FaTelegramPlane,
    link: "#",
    name: "Telegram",
  },
  {
    Icon: FaTwitter,
    link: "#",
    name: "Twitter",
  },
  {
    Icon: FaMediumM,
    link: "#",
    name: "Medium",
  },
  {
    Icon: FaFacebookF,
    link: "#",
    name: "Facebook",
  },
  {
    Icon: FaLinkedinIn,
    link: "#",
    name: "Linkedin",
  },
  {
    Icon: FaGithub,
    link: "#",
    name: "Github",
  },
  {
    Icon: FaYoutube,
    link: "#",
    name: "Youtube",
  },
];

const SocialIcons = () => {
  return (
    <Stack direction={"row"}>
      {socials.map(({ Icon, link, name }) => (
        <Link href={link} target={"_blank"}>
          <IconButton key={name} icon={<Icon />} _hover={{ bg: "brand.600", color: "white" }} />
        </Link>
      ))}
    </Stack>
  );
};

const Footer = () => {
  return (
    <VStack borderTop={"1px solid"} borderColor={"gray.300"} p={8} mt={"16"} spacing={"6"}>
      <SocialIcons />
      <Text pt={6} fontSize={{ lg: "sm", base: "xs" }} textAlign={"center"}>
        © {new Date().getFullYear()} CoinGov. All rights reserved
      </Text>
    </VStack>
  );
};

export default Footer;
